import type { UserGroupHydraItem } from "@verbleif/lib/src/composables/Api/Type/UserGroup/user_group.interface";

import { computed, ref } from "vue";

export function useSharedStoreUserGroups() {
  const userGroups = ref<Record<string, UserGroupHydraItem>>({});

  const userGroupsList = computed<UserGroupHydraItem[]>(() => {
    return Object.values(userGroups.value);
  });

  function _reset() {
    userGroups.value = {};
  }

  return {
    userGroups,
    userGroupsList,
    _reset,
  };
}
